module.exports = __webpack_public_path__ + "assets/devices/Expander33-0ce950d52b76c88b69d61a974b3c5df6.svg";